import { Store } from 'redux';

export const getStoreRef = (): Store => {
  if (!window.__STORE__) {
    throw new Error('Redux store not found!');
  }

  return window.__STORE__;
}
